<template>
    <div class="singleAreaChart"></div>
</template>

<script>
export default {
    name: '',
    props: {
        selectRangeDate: Array,
        pondsid:Number
    },
    data() {
        return {
            myChart:null,
            xData:[],
            yData:[]
        }
    },
    methods: {
        setData1(type) {
            let arr = [];
            switch (type) {
                case 'x':
                    for (let i = 0; i < this.selectRangeDate.length; i++) {
                        arr.push(this.selectRangeDate[i][1] + "." + this.selectRangeDate[i][2])
                    }
                    break;
                case 's' :
                    for (let i = 0; i < this.selectRangeDate.length; i++) {
                        arr.push((Math.random() * 250).toFixed(0))
                    }
                    break;

                default:
                    break;
            }

            return arr;
        },
        setData(){
            this.request.get("/api/Echart/getArtpage2",{
                params: {
                    pondsid:this.pondsid,
                    param: "an",
                    number:10
                }
            }).then(res => {
                if(res.code == 200){
                    let data = res.data;
                    this.xData = data.map(item =>{ // 假设 item.time 是 "2024-03-30T10:03:47"  
                    const dateParts = item.date.split('-'); 
                    const month = dateParts[1];
                    const day = dateParts[2].split('T')[0]; 
                    return `${month}-${day}`;});
                    this.yData = data.map(item => item.an)    
                }
                this.setChart()
            })
        },
        setChart() {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#6dd0e3',
                        fontSize: 10,
                    },
                },
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: true
                    },
                    z: 2,
                    // data: this.setData1('x')
                    data: this.xData

                },
                yAxis:
                    {
                        type: 'value',
                        interval: 0.1,
                        min: 0,
                        max: 1,
                        splitNumber: 7,
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10
                        },
                        splitLine: {
                            show: false,
                        },
                        name: '(mg/L)',
                        nameGap: -10,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                    },

                series: [{
                    name: '氨氮浓度',
                    type: 'line',
                    symbol: 'none',
                    smooth: true,
                    // data: [
                    //     0.3,0.5,0.8,0.47,0.52,0.91,0.73,0.3,0.5,0.8,0.47,0.52,0.91,0.73,
                    //     0.3,0.5,0.8,0.47,0.52,0.91,0.73,0.3,0.5,0.8,0.47,0.52,0.91,0.73,
                    //     0.3,0.5,0.8,0.47,0.52,0.91,0.73
                    // ],
                    data : this.yData,
                    lineStyle: {
                        width: 1,
                        color:{
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#B21356' // 0% 处的颜色
                            },
                                {
                                    offset: 0.5, color: '#B21356' // 40% 处的颜色
                                }, {
                                    offset: 1, color: '#F59111' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        } //背景渐变色
                    },
                    itemStyle: {
                        color: 'rgb(212,37,43)'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#A41B68' // 0% 处的颜色
                            },
                                {
                                    offset: 0.5, color: 'rgba(112,20,82,1)' // 40% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(112,20,82,0)' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        }, //背景渐变色
                        origin: 'start'
                    }
                },
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
        }
    },
    mounted() {
        // this.setChart()
        this.setData()
    },
    watch: {
        pondsid() {
            // this.setChart()
            this.setData()
        }
    }
}
</script>

<style lang="less" scoped>
.singleAreaChart {
    width: 100%;
    height: 100%;
}
</style>
